module.exports = __webpack_public_path__ + "static/media/TireSize.e66b2fcc.svg";